// ----------------------
// <auto-generated>
// Generated using the script apiGenerator.js
// </auto-generated>
// -----------------------
import { configuration } from 'config/constants';
import {
    DisclaimersClient,
    TermsOfUsesClient,
} from './LegalApiClient';
import { http } from 'services/ApiService/Http';

const { baseApiUrls: { legal: baseApiUrl } } = configuration;

export const DisclaimersApi = new DisclaimersClient(baseApiUrl, http);
export const TermsOfUsesApi = new TermsOfUsesClient(baseApiUrl, http);
